<template>
  <div
    class="page_container goodsManageSet"
    v-loading="loading"
    element-loading-text="请稍后"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >SKU管理</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/commondityIndex/cManageIndex' }"
          >商品管理</el-breadcrumb-item
        >
        <el-breadcrumb-item>商品基础信息设置</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!--  主要内容 start -->
    <div class="form_container">
      <h1>商品基础信息设置</h1>
      <div class="content_wrap flex-between">
        <div class="form_wrap">
          <div class="block">
            <p class="b"><span class="mark">*</span>商品名称：</p>
            <div class="block_wrap flex-rowl">
              <span>中文名称</span>
              <div class="input_box">
                <el-input
                  v-model="formData.commodityname"
                  placeholder="输入商品中文名称"
                ></el-input>
              </div>
            </div>
            <div class="block_wrap flex-rowl">
              <span>英文名称</span>
              <div class="input_box">
                <el-input
                  v-model="formData.commodityname_e"
                  placeholder="Enter product name"
                ></el-input>
              </div>
            </div>
            <div class="block_wrap flex-rowl">
              <span>越南语名称</span>
              <div class="input_box">
                <el-input
                  v-model="formData.commodityname_y"
                  placeholder="Nhập tên sản phẩm"
                ></el-input>
              </div>
            </div>
            <div class="block_wrap flex-rowl">
              <span>俄语名称</span>
              <div class="input_box">
                <el-input
                  v-model="formData.commodityname_m"
                  placeholder="Название товара"
                ></el-input>
              </div>
            </div>
            <div class="block_wrap flex-rowl">
              <span>泰语名称</span>
              <div class="input_box">
                <el-input
                  v-model="formData.commodityname_t"
                  placeholder="ป้อนชื่อสินค้า"
                ></el-input>
              </div>
            </div>
            <div class="block_wrap flex-rowl">
              <span>日语名称</span>
              <div class="input_box">
                <el-input
                  v-model="formData.commodityname_r"
                  placeholder="日本語の名称です"
                ></el-input>
              </div>
            </div>
          </div>
          <div class="block">
            <p class="b"><span class="mark">*</span>商品简称</p>
            <div class="block_wrap flex-rowl">
              <span>中文简称</span>
              <div class="input_box">
                <el-input
                  v-model="formData.shortname"
                  placeholder="请输入商品简称"
                  maxlength="30"
                ></el-input>
              </div>
            </div>
            <div class="block_wrap flex-rowl">
              <span>英文简称</span>
              <div class="input_box">
                <el-input
                  v-model="formData.shortname_e"
                  placeholder="Please enter the abbreviation for this product"
                  maxlength="30"
                />
              </div>
            </div>
            <div class="block_wrap flex-rowl">
              <span>越南语简称</span>
              <div class="input_box">
                <el-input
                  v-model="formData.shortname_y"
                  placeholder="Vui lòng nhập tên viết tắt của sản phẩm này"
                  maxlength="30"
                />
              </div>
            </div>
            <div class="block_wrap flex-rowl">
              <span>俄语简称</span>
              <div class="input_box">
                <el-input
                  v-model="formData.shortname_m"
                  placeholder="Пожалуйста, введите аббревиатуру для этого продукта"
                  maxlength="30"
                />
              </div>
            </div>
            <div class="block_wrap flex-rowl">
              <span>泰语简称</span>
              <div class="input_box">
                <el-input
                  v-model="formData.shortname_t"
                  placeholder="กรุณากรอกคำย่อสำหรับผลิตภัณฑ์นี้"
                  maxlength="30"
                />
              </div>
            </div>
            <div class="block_wrap flex-rowl">
              <span>日语简称</span>
              <div class="input_box">
                <el-input
                  v-model="formData.shortname_r"
                  placeholder="日本語の略称です"
                  maxlength="30"
                />
              </div>
            </div>
          </div>

          <div class="block">
            <p class="b"><span class="mark">*</span>商品类型</p>
            <div class="radio_box">
              <el-radio-group v-model="formData.comtype">
                <el-radio
                  v-for="item in columnsGoodsType"
                  :key="item"
                  :label="item"
                  >{{ item }}</el-radio
                >
              </el-radio-group>
            </div>
          </div>

          <div class="block shop_label_wrap">
            <p class="b"><span class="mark">*</span>商品所属分类</p>
            <div class="radio_box">
              <p>请选择一级分类</p>
              <el-radio-group
                v-model="formData.labelid"
                @change="handleChangeLabel1($event, true)"
              >
                <el-radio
                  v-for="item in labelChilds1"
                  :key="item.id"
                  :label="item.id"
                  >{{ item.labelname }}</el-radio
                >
              </el-radio-group>
            </div>
            <!-- <div class="select_box">
              <el-select
                v-model="formData.labelid"
                placeholder="请选择一级分类"
                @change="handleChangeLabel1($event, true)"
              >
                <el-option
                  v-for="item in labelChilds1"
                  :key="item.id"
                  :label="item.labelname"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div> -->
            <div class="radio_box" v-if="labelChilds2.length > 0">
              <p>请选择二级分类</p>
              <el-radio-group
                v-model="formData.labelid2"
                @change="handleChangeLabel2($event, true)"
              >
                <el-radio
                  v-for="item in labelChilds2"
                  :key="item.id"
                  :label="item.id"
                  >{{ item.labelname }}</el-radio
                >
              </el-radio-group>
            </div>
            <!-- <div class="select_box">
              <el-select
                v-model="formData.labelid2"
                placeholder="请选择二级分类"
                @change="handleChangeLabel2($event, true)"
              >
                <el-option
                  v-for="item in labelChilds2"
                  :key="item.id"
                  :label="item.labelname"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div> -->
            <div class="radio_box" v-if="labelChilds3.length > 0">
              <p>请选择三级分类</p>
              <el-radio-group v-model="formData.labelid3">
                <el-radio
                  v-for="item in labelChilds3"
                  :key="item.id"
                  :label="item.id"
                  >{{ item.labelname }}</el-radio
                >
              </el-radio-group>
            </div>
            <!-- <div class="select_box">
              <el-select
                v-model="formData.labelid3"
                placeholder="请选择三级分类"
              >
                <el-option
                  v-for="item in labelChilds3"
                  :key="item.id"
                  :label="item.labelname"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div> -->
          </div>

          <div class="block">
            <p class="b"><span class="mark">*</span>商品结算类型</p>
            <div class="radio_box">
              <el-radio-group v-model="formData.paytype">
                <el-radio
                  v-for="item in columnsGoodsSettleType"
                  :key="item.value"
                  :label="item.value"
                  >{{ item.label }}</el-radio
                >
              </el-radio-group>
            </div>
            <!-- <div class="select_box">
              <el-select
                v-model="formData.paytype"
                placeholder="请选择商品结算类型"
              >
                <el-option
                  v-for="item in columnsGoodsSettleType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div> -->
          </div>

          <div class="block">
            <p class="b"><span class="mark">*</span>是否提供Ai试穿服务</p>
            <div class="radio_box">
              <el-radio-group v-model="formData.isableware">
                <el-radio label="是">是</el-radio>
                <el-radio label="否">否</el-radio>
              </el-radio-group>
            </div>
          </div>
        </div>
        <div class="tip_wrap">
          <div class="item">
            <h1>商品SKU采购编码：</h1>
            <p>{{ detail.sku }}</p>
          </div>
          <div class="item">
            <h1>商品ISBN编码：</h1>
            <p>{{ detail.ISBN }}</p>
          </div>
          <div class="item">
            <h1>商品品牌：</h1>
            <p>{{ detail.brandname }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="form_footer flex-rowl">
      <div class="btn" @click="query">确认</div>
      <div class="return_txt" @click="handleReturn">←返回</div>
    </div>
    <!--  主要内容 end -->
  </div>
</template>

<script>
import {
  getCommidityDetail,
  getCommondityLabel,
  editCommidity,
  encryptstringview,
} from "../../../api/api";
export default {
  name: "cBaseinfo",
  data() {
    return {
      loading: false,
      columnsGoodsType: [
        "普通商品",
        "普通用户积分礼品",
        "商务用户积分礼品",
        "企业积分商品",
      ],
      columnsGoodsSettleType: [
        { value: "零售或批发购买", label: "零售或批发购买" },
        { value: "普通用户积分兑换", label: "普通用户积分兑换" },
        { value: "商户合作用户积分兑换", label: "商户合作用户积分兑换" },
        { value: "企业积分", label: "企业积分" },
      ],

      allLabel: [],
      labelChilds1: [],
      labelChilds2: [],
      labelChilds3: [],

      id: "",
      detail: "",
      formData: {
        Method: "ams_shop_commodity_edit",
        id: "",
        commodityname: "",
        commodityname_e: "",
        commodityname_m: "",
        commodityname_y: "",
        commodityname_t: "",
        commodityname_r: "",
        shortname: "",
        shortname_e: "",
        shortname_m: "",
        shortname_y: "",
        shortname_t: "",
        shortname_r: "",
        comtype: "",
        labelid: "",
        labelid2: "",
        labelid3: "",
        paytype: "",
        isableware: ''  // 是否试穿 是、否
      },
    };
  },
  created() {
    let { routerList, OPENID } = this.$store.state;
    let { name } = this.$route;
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id } = JSON.parse(res.jsondata);
        this.id = id;
        this.getShopLabel();
      } else {
        this.$router.back();
      }
    },

    getDetail() {
      this.loading = true;
      getCommidityDetail({ id: this.id }).then((res) => {
        this.detail = res;
        this.formData.id = res.id ? res.id : "";
        this.formData.commodityname = res.commodityname
          ? res.commodityname
          : "";
        this.formData.commodityname_e = res.commodityname_e
          ? res.commodityname_e
          : "";
        this.formData.commodityname_m = res.commodityname_m
          ? res.commodityname_m
          : "";
        this.formData.commodityname_y = res.commodityname_y
          ? res.commodityname_y
          : "";
        this.formData.commodityname_t = res.commodityname_t
          ? res.commodityname_t
          : "";
        this.formData.commodityname_r = res.commodityname_r
          ? res.commodityname_r
          : "";
        this.formData.shortname = res.shortname ? res.shortname : "";
        this.formData.shortname_e = res.shortname_e ? res.shortname_e : "";
        this.formData.shortname_m = res.shortname_m ? res.shortname_m : "";
        this.formData.shortname_y = res.shortname_y ? res.shortname_y : "";
        this.formData.shortname_t = res.shortname_t ? res.shortname_t : "";
        this.formData.shortname_r = res.shortname_r ? res.shortname_r : "";
        this.formData.comtype = res.comtype ? res.comtype : "";
        this.formData.labelid = res.labelid ? res.labelid : "";
        if (res.labelid) {
          this.handleChangeLabel1(res.labelid);
        }
        this.formData.labelid2 = res.labelid2 ? res.labelid2 : "";
        if (res.labelid2) {
          this.handleChangeLabel2(res.labelid2);
        }
        this.formData.labelid3 = res.labelid3 ? res.labelid3 : "";
        this.formData.paytype = res.paytype ? res.paytype : "";
        this.formData.isableware = res.isableware ? res.isableware : "";

        this.loading = false;
      });
    },

    // 获取商品分类标签
    getShopLabel() {
      getCommondityLabel().then((res) => {
        let filter = res
          .filter((v) => v.labelstate == 1)
          .sort((a, b) => a.sort - b.sort);
        this.allLabel = filter;
        this.labelChilds1 = filter;
        this.getDetail();
      });
    },
    // 触发一级分类，获取二级数据
    handleChangeLabel1(e, isClick) {
      let { allLabel } = this;
      let labelChilds2 = [];
      allLabel.forEach((v) => {
        if (v.id == e) {
          labelChilds2 = v.childs2;
        }
      });
      this.labelChilds2 = labelChilds2
        .filter((item) => item.labelstate === "1")
        .sort((a, b) => a.sort - b.sort);
      if (isClick) {
        this.labelChilds3 = [];
        this.formData.labelid2 = "";
        this.formData.labelid3 = "";
      }
    },
    // 触发二级分类，获取三级数据
    handleChangeLabel2(e, isClick) {
      let { labelChilds2 } = this;
      let labelChilds3 = [];
      labelChilds2.forEach((v) => {
        if (v.id == e) {
          labelChilds3 = v.childs3;
        }
      });
      this.labelChilds3 = labelChilds3
        .filter((item) => item.labelstate === "1")
        .sort((a, b) => a.sort - b.sort);
      if (isClick) {
        this.formData.labelid3 = "";
      }
    },

    query() {
      let { formData } = this;
      if (formData.commodityname.length < 2) {
        this.$message.warning("请输入商品名称最少2个字符");
        return;
      }
      if (formData.shortname.length < 2) {
        this.$message.warning("请输入商品简称最少2个字符");
        return;
      }
      if (formData.shortname_e != "" && formData.shortname_e) {
        if (formData.shortname_e.length < 2) {
          this.$message.warning("请输入商品简称最少2个字符");
          return;
        }
      }
      if (formData.shortname_m != "" && formData.shortname_m) {
        if (formData.shortname_m.length < 2) {
          this.$message.warning("请输入商品简称最少2个字符");
          return;
        }
      }
      if (formData.shortname_y != "" && formData.shortname_y) {
        if (formData.shortname_y.length < 2) {
          this.$message.warning("请输入商品简称最少2个字符");
          return;
        }
      }
      if (formData.shortname_t != "" && formData.shortname_t) {
        if (formData.shortname_t.length < 2) {
          this.$message.warning("请输入商品简称最少2个字符");
          return;
        }
      }
      if (formData.comtype == "" || formData.comtype == null) {
        this.$message.warning("请选择商品类型");
        return;
      }
      if (formData.labelid == "" || formData.labelid == null) {
        this.$message.warning("请选择商品分类");
        return;
      }
      if (formData.paytype == "" || formData.paytype == null) {
        this.$message.warning("请选择商品结算类型");
        return;
      }
      if (formData.isableware == "") {
        this.$message.warning("请选择是否提供Ai试穿服务");
        return;
      }
      this.loading = true;
      editCommidity(formData).then((res) => {
        if (res.result) {
          this.loading = false;
          this.$message.success(res.message);
          // setTimeout(() => {
          //   message.close();
          //   history.back();
          // }, 1500);
          // setTimeout(() => {
          //   this.loading = false;
          //   this.$router.back();
          // }, 500);
        } else {
          this.loading = false;
          this.$message.error(res.message || "服务器报错，请稍后～");
        }
      });
    },

    handleReturn() {
      // history.back();
      this.$router.push({ name: "cManageIndex" });
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManageSet {
  .form_container {
    .content_wrap {
      .form_wrap {
        margin-right: 100px;
        .block_wrap {
          margin-bottom: 20px;
          span {
            font-size: 12px;
            margin-right: 10px;
            width: 60px;
            flex-shrink: 0;
          }
          .input_box {
            margin-bottom: 0;
            flex: 1;
          }
        }
        .radio_box {
          .el-radio {
            margin-bottom: 10px;
          }
        }
        .shop_label_wrap {
          .radio_box {
            margin: 30px 10px;
            p {
              font-size: 14px;
            }
            &:last-child {
              margin-bottom: 0;
            }
          }
        }
      }
      .tip_wrap {
        flex: 1;
        .item {
          margin-bottom: 30px;
          color: #6e6e6e;
          h1 {
            margin-bottom: 8px;
            font-size: 18px;
          }
          p {
            font-size: 16px;
          }
        }
      }
    }
  }
}
</style>